// La fenêtre « Gérer la page » : nom, catégorie, description, logo, couverture.
//
// Sortie de `views/page.js`, dont l'écran est passé à React. Elle reste en HTML
// comme les autres fenêtres modales : elle s'ouvre, se remplit, se ferme, et n'a
// pas d'état qui vive dans le temps.
//
// Elle rend la page modifiée à `apres(pg)` plutôt que de redessiner elle-même :
// c'est l'écran qui sait ce qu'il doit rafraîchir.

import Store from "../store.js";
import { esc, toast, modale } from "../ui.js";
import { icone } from "../icones.js";
import { CATEGORIES, categorieDe } from "../espaces-meta.js";

export function gererPage(pg, id, apres) {
  const { el } = modale({
    titre: "Gérer la page",
    corps: `
      <div class="edit-couverture" id="apercu-couv"${pg.couverture ? ` style="background-image:url('${esc(pg.couverture)}')"` : ""}>
        <label class="btn btn--fantome btn--petit">${icone("appareil", { taille: 16 })} Couverture<input type="file" data-cible="couverture" accept="image/*" hidden></label>
      </div>
      <div class="edit-photo">
        <span class="page-logo" id="apercu-logo">${pg.image ? `<img src="${esc(pg.image)}" alt="">` : categorieDe(pg.categorie).icone}</span>
        <label class="btn btn--fantome btn--petit">${icone("appareil", { taille: 16 })} Logo<input type="file" data-cible="image" accept="image/*" hidden></label>
      </div>
      <label class="label">Nom<input class="champ" id="m-nom" maxlength="60" value="${esc(pg.nom)}"></label>
      <label class="label">Catégorie
        <div class="filtres" id="m-cats">
          ${CATEGORIES.map((c) => `<button class="chip${c.id === pg.categorie ? " est-actif" : ""}" data-cat="${esc(c.id)}">${c.icone} ${esc(c.label)}</button>`).join("")}
        </div>
      </label>
      <label class="label">Description<textarea class="champ" id="m-desc" rows="3" maxlength="600">${esc(pg.description || "")}</textarea></label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Enregistrer",
        classe: "btn--primaire",
        onClick: async (fond, fermer) => {
          const nom = fond.querySelector("#m-nom").value.trim();
          if (!nom) return toast("Le nom est obligatoire", "erreur");
          const patch = {
            nom,
            categorie: fond.querySelector("[data-cat].est-actif")?.dataset.cat || pg.categorie,
            description: fond.querySelector("#m-desc").value.trim(),
          };
          if (nouvelles.image !== undefined) patch.image = nouvelles.image;
          if (nouvelles.couverture !== undefined) patch.couverture = nouvelles.couverture;
          fermer();
          try {
            await Store.pages.modifier(id, patch);
            apres?.({ ...pg, ...patch });
            toast("Page mise à jour");
          } catch (e) {
            toast(e.message || "Enregistrement impossible", "erreur");
          }
        },
      },
    ],
  });

  const nouvelles = {};
  el.querySelector("#m-cats").addEventListener("click", (e) => {
    const b = e.target.closest("[data-cat]");
    if (!b) return;
    el.querySelectorAll("[data-cat]").forEach((x) => x.classList.toggle("est-actif", x === b));
  });
  el.querySelectorAll("[data-cible]").forEach((entree) =>
    entree.addEventListener("change", async (e) => {
      const f = e.target.files?.[0];
      if (!f) return;
      const cible = e.target.dataset.cible;
      try {
        const url = await Store.upload(f, "image");
        nouvelles[cible] = url;
        if (cible === "image") el.querySelector("#apercu-logo").innerHTML = `<img src="${esc(url)}" alt="">`;
        else el.querySelector("#apercu-couv").style.backgroundImage = `url('${url}')`;
      } catch (err) {
        toast(err.message || "Image impossible à charger", "erreur");
      }
    })
  );
}
